import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "assets/css/grid_table.css";
import Select from "react-select";
import moment from "moment";
import numeral from "numeral";
import { getDataApi, saveApi, loadApi } from "services/appApi";
// import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";

const ShipmentDetail = () => {
  let emptyRow = {
    ship_confirm_date: "",	
    estimated_arrival_date: "",	
    delivery_number: "",	
    order_number: "",	
    item_number: "",	
    ecommerce_flag: null,	
    ship_to_city: "",	
    ship_to_state: "",	
    ship_to_zip: "",	
    shipment_quantity: "",	
    shipment_quantity_uom: "",	
    gross_weight_lb: "",	
    gross_volume: "",	
    gross_volume_cm:"",
    sales_channel:""
  };
  
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [code, setCode] = useState([]);
  const [orgCode, setorgCode] = useState({label: "CO", value: "CO"})
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [orgName, setOrgName] = useState("203");
  const toast = useRef(null);
  const dt = useRef(null);
  const pageRows = 200;
  const rowsPerPageOptions = [200, 250, 300, 350];

  useEffect(() => {
        const fetchCode = async () => {
          try {
            let res = await loadApi("","/api/shipAuditData/getUsStateCodes");
            if (res) {
              let successFlag = res.data[0];
              console.log("Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.geography_name,
                  value: item.geography_name
                }))
                setCode(options)
              } 
            }
          } catch (err) {
            console.log(err);
          }
        };
        fetchCode();
      }, []);

  useEffect(() => {
    const fetchData = async () => {
      const yesterday = moment().subtract(1, "days").set({
        hour: 7,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      //let formattedStartDate = yesterday.format("yyyy-MM-DD");1/1/2024
      let formattedStartDate =("2024-01-01")
      setStartDate(formattedStartDate);

      const tomorrow = moment().add(0, "days").set({
        hour: 6,
        minute: 59,
        second: 0,
        millisecond: 0,
      });
      //let formattedEndDate = tomorrow.format("yyyy-MM-DD");12/31/2024
      let formattedEndDate = ("2024-12-31");
      setEndDate(formattedEndDate);
    };

    fetchData();
  }, []);

  const handleLoadData = async () => {

    const p_param = {
      p_org_id: orgName,
      p_ship_to_state_code: orgCode.value,
      p_start_date: startDate,
      p_end_date: endDate
    };
    console.log(p_param);
    try {
      setIsLoading(true);
      const response = await loadApi(p_param, "api/shipAuditData/getShipAuditDataDtl");
      console.log("Fetched Data:", response.data);
      console.log(response.data[0]);
      console.log(response.data[1]);
      if (response.data.length > 0) {
        let successFlag = response.data[0];
        if (successFlag === "Y") {
          toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
          console.log("success=Y");
          setRows(response.data[1]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(false);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
          const errorInfo = response.data[2];
          // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }
        //setSearch(response.data);
      } else {
        //setRows(null);
        setRows([]);
        setIsLoading(false);
        setWasDataFetchingSuccessful(true);
      }

      //setRows(response.data);
    } catch (error) { 
      if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const hideDialog = () => {
    setErrorDialogVisible(false);
  };
  const shipDateTemplate = (rowData) => {
     return rowData.ship_confirm_date ? moment.utc(rowData.ship_confirm_date).format("YYYY-MM-DD") : null;
  };
  const arrivalDateTemplate = (rowData) => {
    return rowData.estimated_arrival_date ? moment.utc(rowData.estimated_arrival_date).format("YYYY-MM-DD") : null;
  };

  const shipQtyTemplate = (rowData) => {
    return numeral(rowData.shipment_quantity).format("0,0");
  };
  const grossWeightTemplate = (rowData) => {
    return numeral(rowData.gross_weight_lb).format("0.00");
  };
  const grossVolumeTemplate = (rowData) => {
    return numeral(rowData.gross_volume).format("0.00");
  };
  const grossVolumeCmTemplate = (rowData) => {
    return numeral(rowData.gross_volume_cm).format("0.0000");
  };
const tableColumns = [

                    {field:"ship_confirm_date",
                    header:"Ship Date"},

                    {field:"estimated_arrival_date",
                    header:"Cust Arrival Date"},

                    {field:"delivery_number",
                    header:"Delivery#"},

                    {field:"order_number",
                    header:"Order#"},

                    {field:"item_number",
                    header:"Item#"},

                    {field:"ecommerce_flag",
                    header:"EcommFlag"},

                    {field:"sales_channel",
                    header:"Sales Type"},

                    {field:"ship_to_city",
                    header:"Ship To City"},

                    {field:"ship_to_state",
                    header:"State"},

                   { field:"ship_to_zip",
                    header:"Zip"},

                   { field:"shipment_quantity",
                    header:"Ship Qty"},

                    {field:"shipment_quantity_uom",
                    header:"UOM"},

                    {field:"gross_weight_lb",
                    header:"Gross Weight(LB)"},

                    {field:"gross_volume",
                    header:"Gross Vol"},

                    {field:"gross_volume_cm",
                    header:"Gross Vol CM"}
      ]
  const formatValue = (field, value) => {
    switch (field) {
      case 'ship_confirm_date' :
        return value ? moment.utc(value).format("YYYY-MM-DD") : null;
      case 'arrivalDateTemplate' :
        return value ? moment.utc(value).format("YYYY-MM-DD") : null;
      case 'shipment_quantity' :
        return numeral(value).format("0,0");
      case 'gross_weight_lb' :
        return numeral(value).format("0.00");
      case 'gross_volume' :
        return  numeral(value).format("0.00");
      case 'gross_volume_cm' :
        return numeral(value).format("0.0000");
      default:
        return value ?? '';
    }
  }

  const exportCSV = () => {
      dt.current.exportCSV();
  };

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
          const headers = tableColumns.map(col=>col.header);
          const dataRows = rows.map((row)=>
          tableColumns.map((col)=>formatValue(col.field, row[col.field])))
           const fullSheetData = [
              [`Organization : ${orgName === "203" ? 'SMG' : orgName === "2" ? 'LD' : ''}`],
              [`State : ${orgCode.value}`],
              [`Start Date : ${startDate}`],
              [`End Date: ${endDate}`],
              [],
              headers,
              ...dataRows
           ]
           const worksheet = xlsx.utils.aoa_to_sheet(fullSheetData)
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'ShipmentDetail');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };


  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Customer Shipment Data for Audit (Detail Report)</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getLoadedHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="header-container">
        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
         Customer Shipment Data for Audit (Detail Report)
              {/* <div className="header-container p-1">
              <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
          <span className="p-input-icon-right w-full md:w-auto"> 
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto text-sm p-3"
          style={{ fontSize: '17px' }} 
        />
      </span>
          </div> */}
          </h2>
        </div>
      </React.Fragment>
    );
  };
  const getErrrorMsgContents = () => {
    return (
      <React.Fragment>
        <div class="row mt-5 justify-content-md-center">
          <div class="col-3">
            <div class="card border-secondary">
              <div class="card-header bg-dark text-white">
                Customer Shipment Data for Audit (Detail Report) table is Unavailable
              </div>
              <div class="card-body card-body-error rounded-bottom">
                <ul>
                  {loadingErrors.map((error) => (
                    <li>error</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getSearchControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline"
        />
      </div>
    </React.Fragment>
  );

  const handleListChange = (selectedOption) => {
    setorgCode(selectedOption);
  }

  const getcodeControl = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Ship To State Code</label>
        <Select
            // className="form-select"
            id="codeId"
            name="codeName"
            onChange={handleListChange}
            options={code}
            value={orgCode}
            placeholder="Select Code"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown1"
            classNamePrefix="select-dropdown1"
          />
      </div>
    </React.Fragment>
  );

  const getStartEndDateControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Start Date</label>
        <div className="input-group date input-wrapper">
        <input
          type="date"
          id="StartDateTime"
          name="StartDateTime"
          value={startDate}
          onChange={handleStartDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">End Date</label>
        <div className="input-group date input-wrapper">
        <input
          type="date"
          id="EndDateTime"
          name="EndDateTime"
          value={endDate}
          onChange={handleEndDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
    </React.Fragment>
  );

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
    const handleRadioChange = (e) => {
    setOrgName(e.target.value); 
  };
    const getOrganizationControl = () => (
      <React.Fragment>
        <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
          <label className="form-label mb-3">Organization</label>
          <div className="d-flex align-items-center">
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                id="org_smg"
                name="orgName"
                value="203"
                checked={orgName === "203"}
                disabled={isLoading}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="org_smg">
                SMG
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="org_ld"
                name="orgName"
                value="2"
                checked={orgName === "2"}
                disabled={isLoading}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="org_ld">
                LD
              </label>
            </div>
          </div>
        </div>
      </React.Fragment>
    );

  const getGoButtonControl = () => (
    <React.Fragment>
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={handleLoadData}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
    </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="flex align-items-center justify-content-start gap-2">
        <Button type="button" icon="pi pi-file" rounded onClick={exportCSV} data-pr-tooltip="CSV" tooltip="CSV" tooltipOptions={{ position: "bottom" }} />
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" tooltip="XLS" tooltipOptions={{ position: "bottom" }}/>
      </div>
    </div>
  );

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {getLoadedHeaderContents()}
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getSearchControls()}
              {getOrganizationControl()}
              {getcodeControl()}
              {getStartEndDateControls()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
                {/* <div className="text-3xl text-800 font-bold mb-4">Customer Shipment Data for Audit (Detail Report)</div> */}
                <DataTable
                  ref={dt}
                  value={rows}
                  scrollable scrollHeight="flex"     
                  selection={selectedRows}
                  onSelectionChange={(e) => setSelectedRows(e.value)}
                  dataKey="file_id"
                  className="custom-datatable-border"
                  tableStyle={{ minWidth: '50rem' }}
                  paginator
                  rows={pageRows}
                  rowsPerPageOptions={rowsPerPageOptions}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
                  globalFilter={globalFilter}
                  header={header}
                  emptyMessage="No data found"
                  stripedRows
                  showGridlines
                >
                  <Column
                    field="ship_confirm_date"
                    header="Ship Date"
                    body={shipDateTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="estimated_arrival_date"
                    header="Cust Arrival Date"
                    body={arrivalDateTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="delivery_number"
                    header="Delivery#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="order_number"
                    header="Order#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="item_number"
                    header="Item#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ecommerce_flag"
                    header="EcommFlag"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                   <Column
                    field="sales_channel"
                    header="Sales Type"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_city"
                    header="Ship To City"
                    sortable
                     style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_state"
                    header="State"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_zip"
                    header="Zip"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="shipment_quantity"
                    header="Ship Qty"
                    body={shipQtyTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="shipment_quantity_uom"
                    header="UOM"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="gross_weight_lb"
                    header="Gross Weight(LB)"
                    body={grossWeightTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="gross_volume"
                    header="Gross Vol"
                    body={grossVolumeTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="gross_volume_cm"
                    header="Gross Vol CM"
                    body={grossVolumeCmTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                </DataTable>
              </div>
            )}
          </div>
        </div>
             <Dialog 
                 header="API Error" 
                 visible={errorDialogVisible} 
                 style={{ width: '400px' }} 
                 onHide={hideDialog} 
                 footer={
                     <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                 }
             >    
              <p>
 
                     {errorMessage}
                 </p>
             </Dialog>
             </div>
    </div>
  );
};

export default ShipmentDetail;